var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 5.66677V2.75065C12.3333 2.05753 12.3333 1.71097 12.1873 1.498C12.0598 1.31192 11.8622 1.18551 11.6398 1.14767C11.3852 1.10435 11.0706 1.24958 10.4413 1.54003L3.04918 4.95176C2.48792 5.2108 2.20729 5.34032 2.00175 5.5412C1.82005 5.71878 1.68135 5.93556 1.59625 6.17496C1.5 6.44576 1.5 6.75483 1.5 7.37299V11.5001M12.75 11.0834H12.7583M1.5 8.33343L1.5 13.8334C1.5 14.7669 1.5 15.2336 1.68166 15.5901C1.84144 15.9037 2.09641 16.1587 2.41002 16.3184C2.76654 16.5001 3.23325 16.5001 4.16667 16.5001H13.8333C14.7668 16.5001 15.2335 16.5001 15.59 16.3184C15.9036 16.1587 16.1586 15.9037 16.3183 15.5901C16.5 15.2336 16.5 14.7669 16.5 13.8334V8.33343C16.5 7.40001 16.5 6.9333 16.3183 6.57678C16.1586 6.26318 15.9036 6.00821 15.59 5.84842C15.2335 5.66677 14.7668 5.66677 13.8333 5.66677L4.16667 5.66677C3.23325 5.66677 2.76654 5.66677 2.41002 5.84842C2.09641 6.00821 1.84144 6.26318 1.68166 6.57678C1.5 6.9333 1.5 7.40001 1.5 8.33343ZM13.1667 11.0834C13.1667 11.3136 12.9801 11.5001 12.75 11.5001C12.5199 11.5001 12.3333 11.3136 12.3333 11.0834C12.3333 10.8533 12.5199 10.6668 12.75 10.6668C12.9801 10.6668 13.1667 10.8533 13.1667 11.0834Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.1ad6c4573029bc56001e8563a0f16134.svg";
export { ForwardRef as ReactComponent };